import { ReactElement } from "react";
import cn from "classnames";

import { Badge } from "./Badge";

interface Props {
  className?: string;
}

const CRBadge = (props: Props): ReactElement => {
  const { className } = props;
  return (
    <Badge
      className={cn(
        "font-medium",
        "text-xs",
        "border",
        "bg-pt-user-role-cr",
        "border-pt-user-role-cr",
        "text-white",
        className
      )}
    >
      TCSSO
    </Badge>
  );
};

export default CRBadge;
